// ─── Hilfsfunktionen ────────────────────────────────────────────────────────

/**
 * Verschiebt alle Inquiry-Modals ins <body>, um z-index/overflow-Probleme zu vermeiden.
 * Der Guard verhindert doppeltes Verschieben.
 */
function initProductInquiryModals(root = document) {
  root.querySelectorAll('[data-product-inquiry-modal]').forEach((modal) => {
    if (modal.dataset.movedToBody === 'true') return;
    

    document.body.appendChild(modal);
    modal.dataset.movedToBody = 'true';
  });
}

/**
 * Liest die aktuell gewählte Variante aus dem variant-picker des zugehörigen Sections
 * und schreibt die Werte in die Hidden Fields des Modals.
 */
function updateProductInquiryVariantData(trigger, modal) {
  const section = trigger.closest('.shopify-section');
  const variantPicker = section?.querySelector('variant-picker');

  // Fallback: Variante aus dem DOM auslesen, falls .variant-Property nicht verfügbar
  const variant = variantPicker?.variant ?? getVariantFromDOM(variantPicker) ?? null;

  const variantIdInput = modal.querySelector('[data-product-inquiry-variant-id]');
  const variantTitleInput = modal.querySelector('[data-product-inquiry-variant-title]');
  const variantSkuInput = modal.querySelector('[data-product-inquiry-variant-sku]');

  if (!variantIdInput || !variantTitleInput || !variantSkuInput) return;

  if (variant) {
    variantIdInput.value = variant.id ?? '';
    variantTitleInput.value = variant.title ?? '';
    variantSkuInput.value = variant.sku ?? '';
  }
}

/**
 * Fallback: Liest Varianten-ID aus einem selektierten Input im variant-picker aus,
 * falls das Custom Element keine .variant-Property exponiert.
 */
function getVariantFromDOM(variantPicker) {
  if (!variantPicker) return null;

  const idInput =
    variantPicker.querySelector('input[name="id"]:not([type="hidden"])') ??
    variantPicker.querySelector('select[name="id"]') ??
    variantPicker.closest('form')?.querySelector('input[name="id"]');

  if (!idInput?.value) return null;

  return { id: idInput.value, title: '', sku: '' };
}

/**
 * Öffnet das Inquiry-Modal nach einem Seiten-Reload (nach Formular-Absenden),
 * wenn der URL-Parameter contact_posted=true gesetzt ist.
 * Blendet die Erfolgsmeldung ein und bereinigt die URL.
 */
function openInquiryModalOnSuccess() {
  const params = new URLSearchParams(window.location.search);
  if (params.get('contact_posted') !== 'true') return;

  // Warte kurz, bis Modals ins Body verschoben wurden
  requestAnimationFrame(() => {
    const modal = document.querySelector('[data-product-inquiry-modal]');
    if (!modal) return;

    // Erfolgsmeldung einblenden
    const successEl = modal.querySelector('[data-product-inquiry-success]');
    if (successEl) successEl.classList.remove('hidden');

    if (typeof modal.open === 'function') {
      modal.open();
    } else {
      console.warn('[ProductInquiry] modal.open() nicht verfügbar auf', modal);
    }

    // URL-Parameter entfernen, ohne die Seite neu zu laden
    const cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete('contact_posted');
    window.history.replaceState({}, '', cleanUrl.toString());
  });
}

// ─── Event Listener ─────────────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', () => {
  initProductInquiryModals();
  openInquiryModalOnSuccess();
});

// Theme Editor: Section neu geladen
document.addEventListener('shopify:section:load', (event) => {
  initProductInquiryModals(event.target);
});

// Theme Editor: Section entfernt → verwaiste Modals aus dem Body entfernen
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-product-inquiry-modal]').forEach((modal) => {
    modal.remove();
  });
});

// Button-Klick: Varianten-Daten aktualisieren und Modal öffnen
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-product-inquiry-open]');
  if (!trigger) return;
  
  event.preventDefault();

  const modalId = trigger.getAttribute('data-product-inquiry-open');
  const modal = document.getElementById(modalId);

  if (!modal) return;

  updateProductInquiryVariantData(trigger, modal);

  if (typeof modal.open === 'function') {
    modal.open(trigger);
  } else {
    console.warn('[ProductInquiry] modal.open() nicht verfügbar auf', modal);
  }
});
